import React from 'react';
import { Route } from 'react-router';
import compose from 'recompose/compose';
import { get } from 'lodash';
import WithBackButton from './hoc/WithBackButton';
import WithNoAutofill from '../hoc/WithNoAutofill';
import WithKioskUrlPattern from '../hoc/WithKioskUrlPattern';
import WithKioskBaseUrl from '../hoc/WithKioskBaseUrl';
import WithKioskContext from '../hoc/WithKioskContext';
import Kiosk from './components/Kiosk';
import Barbers from '../barbers/Barbers';
import Services from '../dynamicBooking/barber/Services';
import MakeReservation from '../reservation/MakeReservation';
import ViewReservation from './ViewReservation';
import { generateUrlString } from '../utils/helpers';
import config from '../../config';

const generateUrl = params => generateUrlString(params, config.urlPatterns.kiosk);

const barberUrl = generateUrl({ shopRoute: '' });
const serviceUrl = generateUrl({ shopRoute: '', barberRoute: '' });
const pickTimeUrl = generateUrl({ shopRoute: '', barberRoute: '', serviceId: '' });

const makeReservationUrl = generateUrl({
  shopRoute: '',
  barberRoute: '',
  serviceId: '',
  reservationTime: '',
});


// Put component in variable to prevent rerendering
const BarberServices = compose(
  WithBackButton,
  WithKioskUrlPattern,
  WithKioskContext,
)(Services);
const MakeReservationContainer = compose(
  WithBackButton,
  WithKioskBaseUrl,
  WithKioskUrlPattern,
  WithNoAutofill,
  WithKioskContext,
)(MakeReservation);
const BarbersContainer = compose(
  WithKioskUrlPattern,
  WithKioskContext,
)(Barbers);

const onChange = (prevState, nextState, replace) => {
  if (get(prevState, 'location.query.startFromAnyBarber') && !get(nextState, 'location.query.startFromAnyBarber')) {
    const newQuery = get(nextState, 'location.query');
    const newLocation = Object.assign({}, nextState.location, { query: { ...newQuery, startFromAnyBarber: true } });
    replace(newLocation);
  }
};

const KioskRoutes = () => (
  <Route onChange={onChange}>
    <Route component={Kiosk}>
      <Route path="/kiosk/view-reservation/:appointmentId" component={WithKioskUrlPattern(ViewReservation)} />
      <Route
        path={barberUrl}
        component={BarbersContainer}
      />
      <Route
        name="services"
        path={serviceUrl}
        component={BarberServices}
        ignoreScrollBehavior
      />
      <Route
        name="picktime"
        path={pickTimeUrl}
        component={BarberServices}
        ignoreScrollBehavior
      />
      <Route
        name="reservation"
        path={makeReservationUrl}
        component={MakeReservationContainer}
      />
    </Route>
  </Route>
);

export default KioskRoutes;



// WEBPACK FOOTER //
// ./src/app/kiosk/routes.jsx